export default "__VITE_ASSET__BSPkc6XP__"